module.exports = __webpack_public_path__ + "media/images/msec_4-3-479a430c1e9aa9c022b59d44c890055e.png";